import { Component, Input } from '@angular/core';
import { DocumentAnalysisTotals } from '@features/dashboard/document-analysis/document-analysis.model';

@Component({
  selector: 'app-document-analysis-summary',
  templateUrl: './document-analysis-summary.component.html',
  styleUrls: ['./document-analysis-summary.component.scss'],
  standalone: false,
})
export class DocumentAnalysisSummaryComponent {
  @Input({ required: true }) totals!: DocumentAnalysisTotals;

  get companiesLabel(): string {
    return this.totals.companies === 1 ? 'empresa' : 'empresas';
  }

  get documentsLabel(): string {
    return this.totals.pending === 1 ? 'documento' : 'documentos';
  }
}
